// extracted by mini-css-extract-plugin
module.exports = {"aussendung":"OTSAussendung_aussendung__TmZKB","meta":"OTSAussendung_meta__YYH2n"};